import { render, staticRenderFns } from "./BarChartAnsweredReport.vue?vue&type=template&id=28b4b542&scoped=true"
import script from "./BarChartAnsweredReport.vue?vue&type=script&lang=js"
export * from "./BarChartAnsweredReport.vue?vue&type=script&lang=js"
import style0 from "./BarChartAnsweredReport.vue?vue&type=style&index=0&id=28b4b542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b4b542",
  null
  
)

export default component.exports